import { defineStore } from 'pinia'

export const useCartStore = defineStore("cartStore", {
  state: () => ({
    items: [],
    quantity: 0,
    coupon: 0
  }),

  getters: {
    total(state) {
      return state.items.reduce((acc, item) => {
        const unitPrice = this.extractUnitPrice(item)
        return acc + unitPrice * item.quantity
      }, 0)
    },
    totalItem(state) {
      return state.items.reduce((acc, item) => acc + item.quantity, 0)
    }
  },

  actions: {
    syncToLocalStorage() {
      localStorage.setItem('cart', JSON.stringify({
        items: this.items,
        quantity: this.quantity,
        total: this.total
      }))
    },

    extractUnitPrice(item) {
      const sku = item?.sku ?? {}
      const product = item?.product ?? {}

      if (sku && Object.keys(sku).length) {
        return sku.sale_price && sku.regular_price && Number(sku.regular_price > sku.sale_price)
          ? sku.sale_price
          : sku.price
      } else {
        return product.sale_price && product.regular_price && Number(product.regular_price > product.sale_price)
          ? product.sale_price
          : product.price
      }
    },

    addToCart(payload) {
      if (!payload?.sku) {
        console.error('No SKU provided')
        return
      }

      const existingItem = this.items.find(item => item?.sku?.id === payload.sku?.id)
      const unitPrice = this.extractUnitPrice(payload)

      if (existingItem) {
        existingItem.quantity += payload.quantity
        existingItem.subTotal = unitPrice * existingItem.quantity
      } else {
        const newItem = {
          product: payload.product,
          sku: payload.sku,
          quantity: payload.quantity,
          subTotal: unitPrice * payload.quantity
        }
        this.items.push(newItem)
      }

      this.quantity += payload.quantity
      this.syncToLocalStorage()
    },

    increase(item) {
      const index = this.items.findIndex(i => i === item)
      if (index !== -1) {
        const unitPrice = this.extractUnitPrice(item)
        this.items[index].quantity++
        this.items[index].subTotal = unitPrice * this.items[index].quantity
        this.quantity++
        this.syncToLocalStorage()
      }
    },

    decrease(item) {
      const index = this.items.findIndex(i => i === item)
      if (index !== -1 && this.items[index].quantity > 1) {
        const unitPrice = this.extractUnitPrice(item)
        this.items[index].quantity--
        this.items[index].subTotal = unitPrice * this.items[index].quantity
        this.quantity--
        this.syncToLocalStorage()
      }
    },

    removeCartItem(item) {
      const index = this.items.findIndex(i => i === item)
      if (index !== -1) {
        const itemQuantity = this.items[index].quantity
        this.quantity -= itemQuantity
        this.items.splice(index, 1)
        this.syncToLocalStorage()
      }
    },

    removeAll() {
      this.items = []
      this.quantity = 0
      this.coupon = 0
      this.syncToLocalStorage()
    },

    addCoupon(amount) {
      this.coupon = amount
      this.syncToLocalStorage()
    },

    initialize() {
      if (typeof window !== 'undefined') {
        const cartJson = localStorage.getItem('cart')
        if (cartJson) {
          const cart = JSON.parse(cartJson)
          this.items = cart.items || []
          this.quantity = Number(cart.quantity || 0)
        }
      }
    }
  }
})
